export const allDepotsConst = "All depots";
